module.exports = __webpack_public_path__ + "static/img/bg@2x.93cc821.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/bg@2x.png
// module id = xB8A
// module chunks = 70